import postscribe from 'postscribe';
import AbstractDriver from './abstract-driver';

/* eslint no-undef: "error" */
class Pardot extends AbstractDriver
{
    constructor()
    {
        super();
        this.firstLoad = false;
    }

    init(config)
    {
        if (!this.firstLoad) this._loadScript(config);
    }

    async pageView()
    {
        // do nothing
    }

    async lead()
    {
        // do nothing
    }

    _exists(showErrors = false)
    {
        return true;
    }

    _loadScript(config)
    {
        postscribe(document.querySelector('head'), `
            <script type="text/javascript">
                piAId = '946693';
                piCId = '';
                piHostname = 'go.luxuriavacations.com';

                (function() {
                    function async_load(){
                        var s = document.createElement('script'); s.type = 'text/javascript';
                        s.src = ('https:' === document.location.protocol ? 'https://' : 'http://') + piHostname + '/pd.js';
                        var c = document.getElementsByTagName('script')[0]; c.parentNode.insertBefore(s, c);
                    }
                    if(window.attachEvent) { window.attachEvent('onload', async_load); }
                    else { window.addEventListener('load', async_load, false); }
                })();
            </script>

        `, {
            done: () =>
            {
                this.firstLoad = true;
                this.init(config);
            },
        });

        return true;
    }
}

export default Pardot;
